import { useEffect, useRef } from "react";

import { scrollTo } from "@/providers/ScrollManagerContext/ScrollManagerContext.utilities";
import { useBaseStore } from "@/store/store";
import { useScrollManager } from "../useScrollManager/useScrollManager";

export function useAutoScrollOnce() {
  const searchContentMatches = useBaseStore(
    (store) => store.searchContentMatches
  );

  const { intersectionMap } = useScrollManager();
  const hasScrolled = useRef<boolean>(false);

  useEffect(() => {
    if (searchContentMatches?.size && !hasScrolled.current) {
      const [[firstKey]] = searchContentMatches;
      const ref = intersectionMap.current.get(firstKey)?.ref;

      scrollTo(ref);
      hasScrolled.current = true;
    }
  }, [intersectionMap, searchContentMatches]);
}
